import { createRoute } from '@tanstack/react-router'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'

export const supportRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/support',
  beforeLoad: ensureAuthenticatedUser,
}).lazy(() => import('./support').then((d) => d.Route))
